export * from "./dataTranslations"
export * from "./errorHandler"
export * from "./mediaQuery"
export * from "./cart"
export * from "./redirect"
export * from "./imgProxy"
export * from "./checkout"
export * from "./promotion"

export const setLocalStorage = (storageKey, value) => localStorage.setItem(storageKey, value)

export const getLocalStorage = (storageKey) => JSON.parse(localStorage.getItem(storageKey))

export const removeLocalStorage = (storageKey) => localStorage.removeItem(storageKey)

export const isNumber = (val) => {
  return (typeof (val) === 'number' || val instanceof Number ||
    (typeof (val) === 'string' && !isNaN(val))) &&
    isFinite(val);
}
